module.exports = __webpack_public_path__ + "img/Comorbidity_PCOS.e12a30a2.jpg";